import { ValidationRuleFunction } from 'vee-validate/dist/types/types';

const equal: ValidationRuleFunction = (field, args) => {
  if (Array.isArray(args)) {
    const target = args[0];
    return `${field}` === `${target}`;
  }
  console.warn('The validator `equal` does not support object syntax.');
  return false;
};

export default equal;
